var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['seo-reaction', _vm.result, _vm.getIsOpen],on:{"click":_vm.onOpen}},[_c('i',{class:_vm.getIconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }